// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import 'font-awesome/css/font-awesome.min.css'

import toastRegistry from '@/components/Toast/index.js'
import loadingRegistry from '@/components/Loading/index.js'
Vue.config.productionTip = false
Vue.use(toastRegistry);
Vue.use(loadingRegistry);

import {contentHeight} from '@/util/rem.js'
Vue.prototype.$contentHeight = contentHeight;

import Astrict from '@/util/astrict'
Vue.use(Astrict)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js